import {
  HttpErrorResponse,
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest
} from "@angular/common/http";
import { Injectable } from "@angular/core";

import { Router } from "@angular/router";
import { ToastrService } from "ngx-toastr";
import { Observable } from "rxjs";
import { tap } from "rxjs/operators";
import { environment } from "../../../environments/environment";
import { AuthService } from "../../core/modules/auth/services/auth.service";

@Injectable()
export class ErrorCamerallaInterceptor implements HttpInterceptor {
  constructor(
    private toastr: ToastrService,
    private authService: AuthService,
    private router: Router
  ) {}

  intercept(
    request: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    return next.handle(request).pipe(
      tap(
        (event: HttpEvent<any>) => {},
        (err: any) => {
          if (err instanceof ProgressEvent || err.status === 0) {
            this.toastr.error(
              "CORS Error or network error. Please check your connection.",
              "Error"
            );
          }


          if (err instanceof HttpErrorResponse) {
            // Handle token failed when user access to Share page.
            if (!err.error.IsSuccess) {
              if (err.error.Message == "Authentication failed.") {
                if (localStorage.getItem("camerallaUser")) {
                  localStorage.removeItem("camerallaUser");
                }
                this.toastr.error("Please try again!!");
                window.location.href = environment["site"] + "/login";
              }

              if (
                err.error.Message ==
                  "Authorization code doesn't exist or is invalid for the client" ||
                err.error.Message == "The authorization code has expired" ||
                err.error.Message == "Account is invalid"
              ) {
                if (localStorage.getItem("camerallaUser")) {
                  localStorage.removeItem("camerallaUser");
                }
                this.toastr.error("Please try to re-login!!");
                window.location.href =
                  environment["site"] + "wp-login.php?action=logout";
              }
            }
          }
        }
      )
    );
  }
}
